<template>
  <div v-if="fileType==='image'">
    <div class="file-field__label text_small">
      {{ label }}
    </div>
    <div class="container container_40 image-input" :class="{ 'disabled': disableField }">
      <input type="file"
             class="download-input"
             :class="{ 'file-loaded': fileUrl }"
             accept="image/*"
             @change="onChange">

      <div class="image-input__inner">

        <div class="image-input__icon">
          <md-icon md-src="/static/img/drag_drop_icon.svg"></md-icon>
        </div>

        <div class="image-input__text">
          <div v-if="fieldType === 'tokenCreation'" class="title" v-html="i18n.lbl_chose_image_token()"></div>
          <div v-else-if="fieldType === 'campaignCreation'" class="title" v-html="i18n.lbl_chose_image_campaign()"></div>
          <div v-else class="title">{{ i18n.lbl_choose_image() }}</div>

          <p class="image-input__note text_x_small" v-for="(note, key) in (fieldType === 'campaignCreation' ? notes_campaign : notes)" :key="key">{{ note }}</p>

          <!--<div v-if="fieldType === 'tokenCreation' || 'campaignCreation'" class="image-input__buttons">
            <div class="image-input__button">
              <label :for="id">{{ i18n.sale_add_button() }}</label>
              <input type="file"
                     accept="image/*"
                     @change="onChange"
                     :id="id"
                     class="image-input__button-handler"
                     :disabled="disableField"
              >
            </div>
            <div v-if="fileUrl" class="image-input__button">
              <md-button type="button"
                         @click="fileDelete()"
                         class="image-input__button-handler"
                         :disabled="disableField"
              >{{ i18n.lbl_delete() }}</md-button>
            </div>
          </div>-->
        </div>

        <div class="image-input__image-preview" v-if="fileUrl">
          <img :src="fileUrl">
        </div>

      </div>
    </div>
  </div>
  <div v-else class="file-field__outer">
    <!--<div v-if="id !== 'documents-tab__file-field'" class="file-field__label text_medium">
      {{ label }}
    </div>
-->
    <div class="file-field">
      <label :for="id" class="file-field__uploader">
        <md-icon v-if="id !== 'documents-tab__file-field'" class="file-field__icon md-icon-size-075x">insert_drive_file</md-icon> <!-- TODO: fix adding icon to buttons -->
        {{ acceptLabel }}
      </label>

      <input type="file"
            class="file-field__input"
            :id="id"
            :name="name"
            :required="required"
            :disabled="disabled"
            :placeholder="placeholder"
            :accept="accept"
            @change="onChange"
      />
    </div>
    <p class="file-field__file-name">
      <button v-if="value && value.file" class="link-btn" type="button" @click="viewNew">
        <span>{{ value.name }}</span>
        <md-icon class="file-field__link-icon md-icon-size-065x">open_in_new</md-icon>
      </button>

      <a :href="fileUrl" target="_blank" v-else-if="value && fileUrl">
        <span>{{ value.name }}</span>
        <md-icon class="file-field__link-icon md-icon-size-065x">open_in_new</md-icon>
      </a>
      <span v-else>{{ i18n.fi_no_file_chosen() }}</span>

    </p>
  </div>
</template>

<script>
  import config from '@conf'
  import FieldMixin from './field.mixin'
  import { DocumentContainer } from '@js/helpers/DocumentContainer'
  import { MAX_FILE_MEGABYTES } from '@const'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { dispatchAppEvent } from '@js/events/helpers'
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'
  import { FileHelper } from '@js/helpers/file.helper'

  export default {
    name: 'file-field',
    mixins: [FieldMixin],
    props: {
      type: { type: String, default: 'default' },
      private: { type: Boolean, default: false },
      minSize: { type: Number, default: null },
      maxSize: { type: Number, default: MAX_FILE_MEGABYTES },
      minWidth: { type: Number, default: null },
      minHeight: { type: Number, default: null },
      accept: { type: String, default: 'image/png, image/jpeg' },
      notes: { type: Array, default: () => i18n.lbl_import_image_details().split('\n') },
      notes_campaign: { type: Array, default: () => i18n.lbl_import_image_details_campaign().split('\n') },
      fileType: { type: String, default: 'default' },
      fieldType: { type: String, default: '' },
      id: { type: String, default: 'imageAddBtn' },
      disableField: { type: Boolean, default: false },
      checkType: { type: Boolean, default: false }
    },
    data: _ => ({
      fileName: '',
      privateUrl: '',
      i18n,
      fileStorage: config.FILE_STORAGE,
      flags: {
        isReadyToDrop: false
      }
    }),
    computed: {
      maxB () {
        return this.maxSize * 1024 * 1024
      },

      minB () {
        return this.minSize * 1024 * 1024
      },

      fileUrl () {
        if (!this.value) return ''
        if (this.value.file) {
          return this.value.dataUrl
        }
        if (!this.private) {
          return this.value.publicUrl
        }
        return this.value.privateUrl
      },

      acceptLabel () {
        switch (this.accept) {
          case '.iss':
            return i18n.fi_upload_iss_file()
          case '.csv':
            return i18n.fi_upload_csv_file({ size: i18n.n(this.maxSize) })
          case '.pdf':
            return i18n.sale_add_button()
          default:
            return i18n.fi_upload_file({ size: i18n.n(this.maxSize) })
        }
      }
    },
    async created () {
      if (this.private && this.value) {
        await this.handlePrivate()
      }
    },
    methods: {
      async onChange (event) {
        const file = FileHelper.deriveFileFromChangeEvent(event)
        if (!this.isValidFileSize(file)) return
        if (file.type.indexOf('image') !== -1) {
          if (!(await this.checkImageDimensions(file))) return
        }

        if (this.checkType) {
          if (!await this.checkFileType(file)) {
            EventDispatcher.dispatchShowErrorEvent(i18n.file_incorrect_type())
            return false
          }
        }

        this.$emit(commonEvents.inputEvent, new DocumentContainer({
          mimeType: file.type,
          type: this.type,
          name: file.name,
          file: file
        }))
      },

      fileDelete () {
        this.$emit(commonEvents.documentDeleteEvent)
      },

      checkFileType (file) {
        const requiredFileType = this.accept.replace('.', '')
        return file.type.indexOf(requiredFileType) !== -1 || file.name.indexOf(requiredFileType) !== -1
      },

      isValidFileSize (file) {
        if (this.maxSize && file.size > this.maxB) {
          EventDispatcher.dispatchShowErrorEvent(i18n.max_file_size_exceeded({ size: this.maxSize }))
          this.clear()
          return false
        } else if (this.minSize && file.size < this.minB) {
          EventDispatcher.dispatchShowErrorEvent(i18n.min_file_size_fail({ size: this.minSize }))
          this.clear()
          return false
        } else {
          return true
        }
      },

      async checkImageDimensions (file) {
        const reader = await FileHelper.readFileAsDataURL(file)
        const image = await FileHelper.readImage(reader)
        if (this.minWidth && this.minHeight && (image.naturalWidth < this.minWidth || image.naturalHeight < this.minHeight)) {
          EventDispatcher.dispatchShowErrorEvent(i18n.min_image_dimension_fail({ width: this.minWidth, height: this.minHeight }))
          return false
        }
        if (this.minWidth && image.naturalWidth < this.minWidth) {
          EventDispatcher.dispatchShowErrorEvent(i18n.min_image_width_fail({ width: this.minWidth }))
          return false
        }
        if (this.minHeight && image.naturalHeight < this.minHeight) {
          EventDispatcher.dispatchShowErrorEvent(i18n.min_image_height_fail({ height: this.minHeight }))
          return false
        }
        return true
      },

      async handlePrivate () {
        if (this.value.derivePrivateUrl) {
          await this.value.derivePrivateUrl()
        }
      },
      clear () {
        this.$el
          .querySelectorAll('input')
          .forEach(input => { input.value = '' })
      },
      viewNew () {
        if (!this.fileUrl) return
        let file = document.getElementById(this.id)
        if (file.files[0].type === 'application/pdf' && file.files.length > 0) {
          let pdfFileURL = URL.createObjectURL(file.files[0])
          window.open(pdfFileURL, '_blank')
        } else {
          dispatchAppEvent(commonEvents.openFileViewEvent, this.fileUrl)
        }
      }
    },
    watch: {
      async value (value) {
        if (!value) return
        if (!value.key) {
          await this.value.deriveDataUrl()
          return
        }
        if (this.private) {
          await this.handlePrivate()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .file-field__outer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .file-field {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .file-field__label {
    margin-bottom: 10px;
  }

  .file-field__uploader {
    display: block;
    margin-right: .5rem;
    padding: .75rem 1rem;
    border-radius: 8px;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    color: $col-text;
    background: $col-md-primary;
    cursor: pointer;
    transition: .4s cubic-bezier(.4,0,.2,1);

    &:hover {
      background: lighten($col-md-primary, 3.5%);
    }
  }

  .file-field__icon {
    margin-right: .5rem;
    position: relative;
    bottom: .05rem;
  }

  .file-field__input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .field-button {
    width: 150px;
    margin: 0 auto;
    text-transform: none;
  }

  .link-btn {
    border: none;
    background: none;
    cursor: pointer;
    color: $col-md-primary;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: none;
    }
  }

  .image-input {
    position: relative;
    width: 460px;
    max-width: 100%;
    height: auto;
    min-height: 238px;
    margin: 20px auto;
    background: $col-background;
    transition: .2s;
    @include border(1px, 16px, $col-border, dashed);

    @include respond-to(small) {
      width: 100%;
    }

    &:hover {
      @include border(1px, 16px, $col-md-primary);
    }

    & input[type="file"] {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      cursor: pointer;
      opacity: 0;
      z-index: 99;

      /*&.file-loaded {
        right: 50%;
        width: 50%;
      }*/
    }

    &.disabled {
      pointer-events: none;
      opacity: .5;
    }

    &__inner {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    &__icon {
      & .md-icon {
        width: 70px;
        height: 64px;
      }
    }

    &__text { /* TODO: fix position of text wrap item */
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 100%;
      text-align: center;

      .title {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 700;

        @include respond-to(small) {
          font-size: 16px;
        }
      }
    }

    &__note {
      color: $col-text-secondary;
    }

    &__image-preview {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: calc(50% - 10px);
      max-height: calc(100% - 10px);
      margin: 24px auto 0;
      border-radius: 10px;
      pointer-events: none;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        border-radius: 10px;
        object-fit: cover;
        pointer-events: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/common/fields/FileField.vue